var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"screen"}},[_c('div',{staticStyle:{"width":"100%","height":"100%","display":"flex","align-items":"center","justify-content":"center","background":"#001529","color":"#fff"}},[_vm._v(" 地图功能已下线 ")])])
}]

export { render, staticRenderFns }